/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesExternalPaymentStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;
export type WebApiModelsEnumerationTypesExternalPaymentStatus = typeof WebApiModelsEnumerationTypesExternalPaymentStatus[keyof typeof WebApiModelsEnumerationTypesExternalPaymentStatus];


export function WebApiModelsEnumerationTypesExternalPaymentStatusFromJSON(json: any): WebApiModelsEnumerationTypesExternalPaymentStatus {
    return WebApiModelsEnumerationTypesExternalPaymentStatusFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesExternalPaymentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesExternalPaymentStatus {
    return json as WebApiModelsEnumerationTypesExternalPaymentStatus;
}

export function WebApiModelsEnumerationTypesExternalPaymentStatusToJSON(value?: WebApiModelsEnumerationTypesExternalPaymentStatus | null): any {
    return value as any;
}

